import $ from "jquery";

const animationLoaded = () => {
  const init = () => {
    execute();
  };

  const execute = () => {
    const el = {
      div: ".js-loaded-animation",
    };

    // $(window).on("load", function () {
    $(el.div).each(function () {
      const delay = $(this).data("delay");
      if (delay) {
        setTimeout(() => {
          $(this).addClass("loaded");
        }, delay);
      } else {
        $(this).addClass("loaded");
      }
    });
    // });
  };

  init();
};

try {
  animationLoaded();
} catch (error) {
  console.error("animationLoaded: ", animationLoaded);
}
